import React from 'react';
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import parse from "html-react-parser";

export default function PostSPCard(params) {

    const page = params.postObject;
    const location = params.location;
    const conteudo = page.conteudo;
    const isPage = page.categoria === "Página";

    if (location === "completo") {
      return (
        <div>
        <Box className="post maincontent">
          <div key={page.id} style={{
            height: "100%"
          }}>
            <div className="postHeader"
            style={isPage ? {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            } : {
              backgroundImage: `url(https://stimatacawca.blob.core.windows.net/miniaturas/${page.miniatura.fileName})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "70vw",
              maxHeight: "50vh",
              alignContent: "end",
            }}>
                <div className="author_card"
                style={{
                  color: "black",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  padding: "10px"
                }}>
                    <h2 >{page.titulo}</h2>
                    {!isPage && <p style={{ margin: "0px"}}>Por: {page.autor} | Tags: {page.tags ? page.tags.map(tag => (tag.LookupValue + " ")) : false}</p>}
                </div>
              </div>
              <div className="postContent" >{parse(conteudo)}</div>
            </div>
          </Box>
        </div>
    
      );
    } else if (location === "lista") {
      const tags = page.tags ? page.tags.map(tag => (tag.LookupValue + " ")) : "";
      return (
        <>
          <Card sx={{ maxWidth: 345 }} className="card">
            <Link to={`/post/${page.url}`}>
            <CardMedia
              sx={{ height: 140 }}
              image={`https://stimatacawca.blob.core.windows.net/miniaturas/${page.miniatura.fileName}`}
              title={page.titulo}
            />
            </Link>
            <CardContent>
              <Link to={`/post/${page.url}`}>
                <Typography gutterBottom variant="h5" component="div" className="post_title_card">
                  {page.titulo}
                </Typography>
              </Link>
              
            <p className="author">Por: {page.autor}</p>
            <p className="author">Tags: {tags}</p>
          
            </CardContent>
          </Card>
        </>
      );
    }

};